export default class LayoutService {
    constructor() {
        LayoutService.fullScreenHeight()
        window.addEventListener('resize', () => {
            LayoutService.fullScreenHeight()
        })
        window.addEventListener('orientationchange', () => {
            LayoutService.fullScreenHeight()
        })
    }

    static fullScreenHeight() {
        if (window.matchMedia('(max-width: 1000px)').matches) {
            const viewportHeight = window.innerHeight
            const headerHeight = $('[data-id="wpiris-navbar"]').innerHeight()
            const bottomBarHeight = $('[data-element="tools"]').innerHeight()
            const element = $('.alignheight')
            let elementHeight = viewportHeight - headerHeight

            if (typeof bottomBarHeight !== 'undefined') {
                elementHeight = elementHeight - bottomBarHeight
            }

            element.css('height', `${elementHeight}px`)
        }
    }
}
